/* eslint max-len:0 */
import React from 'react'
import { Helmet } from 'react-helmet'
import { ToastContainer } from 'react-toastify'

import { ErrorBoundary } from '@duplo/utils/lib/errorTracking'

import 'react-toastify/dist/ReactToastify.min.css'

const enabledTrustedform = [10034, 10129, 10133, 10178, 10179, 10654, 10729, 10793, 10814]

const TemplateWrapper = ({ children }) => {
	if (!(typeof window !== 'undefined')) return null

	const path = window.location.pathname.split('/')

	const templateContents = (
		<>
			{enabledTrustedform.includes(Number(path[1])) && (
				<Helmet>
					<script type="text/javascript">
						{`(function()  { var field = 'xxTrustedFormCertUrl'; var provideReferrer = false; var invertFieldSensitivity = false; var tf = document.createElement('script'); tf.type = 'text/javascript'; tf.async = true; tf.src = 'http' + ('https:' == document.location.protocol ? 's' : '') + '://cfptwebapi.cfdomains.com/trustedform.js?provide_referrer=' + escape(provideReferrer) + '&field=' + escape(field) + '&l='+new Date().getTime()+Math.random() + '&invert_field_sensitivity=' + invertFieldSensitivity; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(tf, s); } )();`}
					</script>
					<noscript>{`<img src="https://cfptwebapi.cfdomains.com/ns.gif" alt="ns.gif" />`}</noscript>
				</Helmet>
			)}
			<div>
				<ToastContainer />
				{children}
			</div>
		</>
	)

	// if we're in the client and can render the error boundry wrap everything in it.
	if (ErrorBoundary) {
		return <ErrorBoundary>{templateContents}</ErrorBoundary>
	}

	return templateContents
}

export default TemplateWrapper
